import React from 'react';
import { Textfit } from 'react-textfit';
import './SidebarLayout.scss';
const SidebarLayout = ({
  footer_text,
  main_image,
  sidebar_image,
  footer_text_color,
  footer_font
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "SidebarLayout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left-col"
  }, /*#__PURE__*/React.createElement("img", {
    src: sidebar_image,
    alt: ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "right-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-img-container"
  }, " ", /*#__PURE__*/React.createElement("img", {
    src: main_image,
    className: "main-img",
    alt: ""
  }), " "), /*#__PURE__*/React.createElement(Textfit, {
    className: "footer-text",
    style: {
      color: footer_text_color,
      fontFamily: footer_font
    }
  }, footer_text)));
};
export default SidebarLayout;